


































































































































































import {
  salaryOrderStaffListInter,
  salaryOrderStaffListApi,
  salaryOrderStaffListExportApi,
} from "@/api/salary";
import { Component, Vue } from "vue-property-decorator";
import { exportLoop } from "@/utils/export";
import { Message } from "element-ui";
@Component({
  components: {},
})
export default class extends Vue {
  searchInfo = {
    name: "",
    month_date: [],
    status: -1,
    amount_start: "",
    amount_end: "",
  };
  tableData = [];
  customTableData = [];
  tableTotal: number = 0; // 表格合计列的总和
  page: number = 1;
  pageSize: number = 10;
  pageSizeArray: number[] = [5, 10, 30, 50, 100];
  total: number = 0;
  pickerOptions = {
    disabledDate(time: any) {
      const year = new Date().getFullYear(); //获取当前年份
      const month = new Date().getMonth() + 1; //获取当前月份
      const tot = new Date(year + "-" + month + "-1").getTime(); //获取当前年月转成时间戳
      // console.log(year, month, new Date(tot).getTime());
      return time.getTime() > tot;
    },
  };
  created() {
    this.getList({
      page: 1,
      page_size: 10,
    });
  }
  handleSearch() {
    this.getList({
      page: 1,
      page_size: this.pageSize,
    });
  }
  getList(val: { page: number; page_size: number }) {
    const params: salaryOrderStaffListInter = {
      page: val.page,
      page_size: val.page_size,
    };
    if (this.searchInfo.name) {
      params.key_word = this.searchInfo.name;
    }
    if (this.searchInfo.month_date && this.searchInfo.month_date.length > 0) {
      params.belong_month_start_date = this.searchInfo.month_date[0];
      params.belong_month_end_date = this.searchInfo.month_date[1];
    }
    if (this.searchInfo.amount_start !== "" && !this.searchInfo.amount_end) {
      this.$message({
        type: "warning",
        message: "请填写最高数值",
      });
      return false;
    }
    if (this.searchInfo.amount_start === "" && this.searchInfo.amount_end) {
      this.searchInfo.amount_start = "0";
    }
    if (this.searchInfo.amount_start && this.searchInfo.amount_end) {
      if (
        Number(this.searchInfo.amount_end) <
        Number(this.searchInfo.amount_start)
      ) {
        this.$message({
          type: "warning",
          message: "最高数值须高于最低数值",
        });
        return false;
      }
      params.amount_start = String(this.searchInfo.amount_start);
      params.amount_end = String(this.searchInfo.amount_end);
    }
    if (this.searchInfo.status > -1) {
      params.is_teach = this.searchInfo.status;
    }
    salaryOrderStaffListApi(params).then((res: any) => {
      if (res.error_code === 0) {
        // 处理合计的数组
        const totalArr: any = [];
        this.tableTotal = 0;
        if (res.data.list && res.data.list.list.length > 0) {
          let num = 1;
          res.data.list.list.map((item: any) => {
            item.num = num++;
            this.tableTotal += Number(item.amount);
            item.item_list.map((it: any) => {
              it.amount = it.item_type === 1 ? it.amount : "-" + it.amount;
              totalArr.push(it);
            });
          });
        }
        this.tableData = res.data.list.list;
        this.total = res.data.list.total;
        if (res.data.field && res.data.field.length > 0) {
          res.data.field.map((item: any) => {
            if (item.name === "基本工资") {
              item.name = item.name + "（元）";
            }
            item.totalAmount = 0;
            totalArr.map((it: any) => {
              if (item.salary_item_id === it.item_id) {
                item.totalAmount += Number(it.amount);
              }
            });
          });
        }
        this.customTableData = res.data.field;
      }
    });
  }
  handleExport() {
    const params: any = {};
    if (this.searchInfo.name) {
      params.key_word = this.searchInfo.name;
    }
    if (this.searchInfo.month_date && this.searchInfo.month_date.length > 0) {
      params.belong_month_start_date = this.searchInfo.month_date[0];
      params.belong_month_end_date = this.searchInfo.month_date[1];
    }
    if (this.searchInfo.amount_start && this.searchInfo.amount_end) {
      params.amount_start = this.searchInfo.amount_start;
      params.amount_end = this.searchInfo.amount_end;
    }
    if (this.searchInfo.status > -1) {
      params.is_teach = this.searchInfo.status;
    }
    salaryOrderStaffListExportApi(params).then((res: any) => {
      if (res.error_code === 0) {
        exportLoop(res.data.task_id);
      }
    });
  }
  handlePagerChange(e: number) {
    this.getList({
      page: e,
      page_size: this.pageSize,
    });
  }
  handlePagerSizeChange(e: number) {
    this.pageSize = e;
    this.getList({
      page: 1,
      page_size: e,
    });
  }
}
